<template>
    <form
        :action="
            urlFactory.makeAuthCompanySelectionStoreUrl(
                company.id,
                destinationUrl,
            )
        "
        method="POST"
        :id="`company-${company.id.value}`"
    >
        <button
            type="submit"
            :form="`company-${company.id.value}`"
            class="block w-full"
        >
            <div
                class="p-2 bg-white rounded-lg2 border hover:ring-2 hover:ring-primary flex items-center gap-4"
            >
                <div class="rounded-lg2 overflow-hidden min-w-fit">
                    <Image
                        class="h-12 w-12 object-cover"
                        :src="company.getLogoUrlWithFallback()"
                    />
                </div>
                <div class="font-medium text-sm text-gray-600 text-start">
                    {{ company.displayName }}
                </div>
            </div>
        </button>
    </form>
</template>

<script setup lang="ts">
    import Company from '@/App/Company/Entity/Company'
    import Image from '@/Shared/Component/Image.vue'
    import type { PropType } from 'vue'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    const urlFactory = new UrlFactory()

    const props = defineProps({
        company: {
            type: Object as PropType<Company>,
            required: true,
        },
        destinationUrl: {
            type: String,
            required: true,
        },
    })
</script>
